<template>
  <div style="padding-bottom: 60px; position: relative; overflow: hidden">
    <div class="customer-quotes-page" style="margin-top: 80px">
      <!--<h1 class="global-h1" style="margin-bottom: 40px">Customer Quotes</h1>-->

      <Loader v-if="isLoading" />

      <div v-else class="logos-and-testimonials-carousels" style="margin: 0 auto">
        <h3 class="global-h3 logos-and-testimonials-carousels__title">Trusted Nationwide: Shrpa Connects Destinations with Top Travel Creators</h3>

        <HorizontalStepCarousel
          class="logos-and-testimonials-carousels__logos-carousel"
          itemWrapClassName="logos-row__logo-wrap"
          itemClassName="logos-row__logo"
          :stepSize="
            {
              'desktop-wide': 3,
              desktop: 3,
              laptop: 3,
              'tablet-large': 2,
              tablet: 2,
              mobile: 2,
            }[screenSize]
          "
          :transitionDuration="200"
        >
          <ul class="logos-row" style="width: 100%">
            <li class="logos-row__logo-wrap" v-for="logoFileName in customerLogos" :key="logoFileName">
              <img class="logos-row__logo" :src="`${contentBaseUri}/cms/images/orgs/${logoFileName}`" :alt="logoFileName" />
            </li>
          </ul>
        </HorizontalStepCarousel>

        <div class="connect-cta" style="text-align: center; margin: 60px 0">
          <div class="global-h3 logos-and-testimonials-carousels__title" style="margin-top: 0; margin-bottom: 20px">Want to see if Shrpa is right for your Destination?</div>
          <SrpButton tag="button" color="orange" @click="openRequestADemoModal" style="box-shadow: 0 8px 30px -5px #ec563b"> Connect With Us Today! </SrpButton>
        </div>

        <div class="logos-and-testimonials-carousels__divider"></div>

        <SrpMasonry
          class="logos-and-testimonials-carousels__quotes-carousel"
          :columns="
            {
              'desktop-wide': 3,
              desktop: 3,
              laptop: 3,
              'tablet-large': 2,
              tablet: 1,
              mobile: 1,
            }[screenSize]
          "
          :columnGap="
            {
              'desktop-wide': 27,
              desktop: 27,
              laptop: 24,
              'tablet-large': 22,
              tablet: 18,
              mobile: 17,
            }[screenSize]
          "
          :items="customerQuotes"
        >
          <template #default="{ item, index, rebuildMasonry }">
            <!-- Testimonial snippet -->
            <div class="testimonial-snippet" style="margin-bottom: 27px">
              <div class="testimonial-snippet__logo-wrap">
                <img v-if="item.customerIcon" class="testimonial-snippet__logo" :src="`${contentBaseUri}/cms/images/orgs/${item.customerIcon}`" :alt="item.fullName" />
              </div>

              <div class="global-h5 testimonial-snippet__text" v-html="formatCustomerQuoteText(item.quoteText, item.quoteAccentText)"></div>

              <div class="testimonial-snippet__divider"></div>

              <div class="testimonial-snippet__name-and-position">
                <div class="global-h4 testimonial-snippet__name">
                  {{ item.fullName }}
                </div>
                <div class="testimonial-snippet__position">
                  {{ item.position }}
                </div>
              </div>
            </div>
            <!-- / Testimonial snippet -->
          </template>
        </SrpMasonry>

        <div class="logos-and-testimonials-carousels__divider"></div>
      </div>

      <!-- Case studies section -->
      <div class="case-studies-section" style="padding-top: 80px">
        <h2 class="global-h2 case-studies-section__title">Case Studies</h2>

        <ul class="case-studies-section__widgets-list">
          <!-- Case study widget -->
          <li class="case-study-widget case-studies-section__widget">
            <RouterLink class="case-study-widget__link-overlay" :to="{ name: 'KeweenawCaseStudy' }" />

            <h4 class="global-h4 case-study-widget__title">How Keweenaw Peninsula Transformed UGC Collection &amp; Creator Collaborations</h4>

            <div class="case-study-widget__summary">
              <p>
                Thanks to Shrpa, Keweenaw now has over 900 photos and videos at their fingertips.<br />
                Their small team efficiently manages seasonal content refreshes and creator collaborations through Shrpa's platform.
              </p>
            </div>

            <div class="case-study-widget__logo-and-name">
              <img class="case-study-widget__logo" src="https://cdn.shrpa.com/cms/images/orgs/f950476c-361c-400b-b45e-7eda7a5dee1d.png" />
            </div>
          </li>
          <!-- / Case study widget -->

          <!-- Case study widget -->
          <li class="case-study-widget case-studies-section__widget">
            <RouterLink class="case-study-widget__link-overlay" :to="{ name: 'CrescentHotelCaseStudy' }" />

            <h4 class="global-h4 case-study-widget__title">How 1886 Crescent Hotel &amp; Spa Leveraged Shrpa for Authentic Content</h4>

            <div class="case-study-widget__summary">
              <p>
                Replacing expensive photoshoots with authentic creator visits, Crescent Hotel & Spa has built a library of 1,500+ genuine photo experiences. <br />
                Their content now captures real moments that resonate with potential visitors across all marketing channels.
              </p>
            </div>

            <div class="case-study-widget__logo-and-name">
              <img class="case-study-widget__logo" src="https://cdn.shrpa.com/cms/images/orgs/37072d51-29fc-46f2-ae28-8a585bf69819.png" />
            </div>
          </li>
          <!-- / Case study widget -->

          <!-- Case study widget -->
          <li class="case-study-widget case-studies-section__widget">
            <RouterLink class="case-study-widget__link-overlay" :to="{ name: 'PutnamWVCaseStudy' }" />

            <h4 class="global-h4 case-study-widget__title">How Putnam County Tourism Transformed Destination Storytelling &amp; Simplified Creator Collaborations</h4>

            <div class="case-study-widget__summary">
              <p>
                What once seemed overwhelming is now effortless. Putnam County's small team manages creator visits with ease, seeing 30+ applicants for single events. <br />
                Their destination story is now told through diverse creator perspectives, reaching new audiences.
              </p>
            </div>

            <div class="case-study-widget__logo-and-name">
              <img class="case-study-widget__logo" src="https://cdn.shrpa.com/cms/images/orgs/324b41f6-12f5-4539-897d-2a9e68ee95e3.png" />
            </div>
          </li>
          <!-- / Case study widget -->
        </ul>
      </div>
      <!-- / Case studies section -->
    </div>
    <RequestADemoFormModal ref="domRefRequestADemoFormModal" />
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import { useHead } from "@unhead/vue";
import "vue-good-table-next/dist/vue-good-table-next.css";

// Components
import HorizontalStepCarousel from "@components/HorizontalStepCarousel.vue";
import Loader from "@components/Loader/Loader.vue";
import SrpMasonry from "@components/ui/SrpMasonry.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import RequestADemoFormModal from "@views/Home/RequestADemoFormModal.vue";

// Helpers
import { formatCustomerQuoteText } from "@/helpers/CustomerQuoteHelper";

// Repos
import CustomerQuotesRepo from "@/repos/CustomerQuotesRepo";

// Types
import { CustomerQuote } from "@contracts/pages";
import { ScreenSize } from "@contracts/screenSize";

export default defineComponent({
  name: "CustomerQuotes",

  components: {
    HorizontalStepCarousel,
    Loader,
    SrpMasonry,
    SrpButton,
    RequestADemoFormModal,
  },

  data() {
    return {
      contentBaseUri: globalThis.Bootstrap.Config.contentCdnBaseUri,
      screenSize: inject("screenSize") as ScreenSize,

      isLoading: true,

      customerLogos: [] as Array<string>,
      customerQuotes: [] as Array<CustomerQuote>,
    };
  },

  computed: {},

  async mounted() {
    useHead({ title: "Customers" });

    await this.loadCustomerQuotes();
  },

  methods: {
    formatCustomerQuoteText,
    openRequestADemoModal() {
      (this.$refs.domRefRequestADemoFormModal as any)?.openModal();
    },
    async loadCustomerQuotes() {
      const data = await CustomerQuotesRepo.getCustomerQuotes({
        state: this.$route.query?.state ? String(this.$route.query.state) : undefined,
        logosCount: this.$route.query?.logosCount ? Number(this.$route.query.logosCount) : undefined,
        quotesCount: this.$route.query?.quotesCount ? Number(this.$route.query.quotesCount) : undefined,
      });

      this.customerLogos = data.logos;
      this.customerQuotes = data.customerQuotes;

      this.isLoading = false;
    },
  },
});
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";
@import "@/scss/screen-size-ranges.scss";

// Case study widget ==========================================================
.case-study-widget {
  padding: 20px 20px 25px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 0;
  box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.37);
  user-select: none;
  cursor: pointer;

  &__link-overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0 auto auto 0;
    z-index: 1;
  }

  &__title {
    margin-bottom: 15px;
    text-align: center;
    text-decoration: underline;
    text-decoration-color: rgba(0, 0, 0, 0.2);
    text-underline-offset: 3px;
    text-decoration-thickness: 1px;
    text-decoration-style: solid;
  }

  &:hover &__title {
    text-decoration: none;
  }

  &__summary {
    margin-bottom: 20px;
    text-align: center;
    font-size: 14px;
    line-height: 1.5;
    color: rgba(91, 91, 91, 1);
  }

  &__logo-and-name {
    gap: 10px;
    padding-top: 15px;
    border-top: 1px rgba(0, 0, 0, 0.1) solid;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &__logo {
    max-width: 140px;
    max-height: 90px;
  }

  &__name {
    font:
      600 15px/17px "Quicksand",
      sans-serif;
    text-align: center;
    text-wrap: balance;
  }
}
// desktop wide -----------------------
@media (min-width: $desktop-wide-min-width) {
}
// desktop ----------------------------
@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
}
// laptop -----------------------------
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
}
// tablet large -----------------------
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
}
// tablet -----------------------------
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
}
// mobile -----------------------------
@media (max-width: $mobile-max-width) {
  .case-study-widget {
    padding: 15px 13px 17px;
  }
}

// Case studies section =======================================================
.case-studies-section {
  &__title {
    margin-bottom: 40px;
    text-align: center;
  }

  &__widgets-list {
    gap: $desktop-wide-grid-gap-width;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    list-style: none;
  }

  &__widget {
    width: $desktop-wide-3-columns;
  }
}
// desktop wide -----------------------
@media (min-width: $desktop-wide-min-width) {
}
// desktop ----------------------------
@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
  .case-studies-section {
    &__widgets-list {
      gap: $desktop-grid-gap-width;
    }

    &__widget {
      width: $desktop-3-columns;
    }
  }
}
// laptop -----------------------------
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
  .case-studies-section {
    &__widgets-list {
      gap: $laptop-grid-gap-width;
    }

    &__widget {
      width: $laptop-3-columns;
    }
  }
}
// tablet large -----------------------
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
  .case-studies-section {
    &__widgets-list {
      gap: $tablet-large-grid-gap-width;
    }

    &__widget {
      width: $tablet-large-4-columns;
    }
  }
}
// tablet -----------------------------
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
  .case-studies-section {
    &__widgets-list {
      gap: $tablet-grid-gap-width;
    }

    &__widget {
      width: $tablet-4-columns;
    }
  }
}
// mobile -----------------------------
@media (max-width: $mobile-max-width) {
  .case-studies-section {
    &__widgets-list {
      gap: $mobile-grid-gap-width;
    }

    &__widget {
      width: $mobile-3-columns;
    }
  }
}

// Logos row ==================================================================
.logos-row {
  padding: 0;
  margin: 0;
  display: flex;
  list-style: none;

  &__logo-wrap {
    height: 95px;
    padding-right: 71px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:last-child {
      padding-right: 0;
    }
  }

  &__logo {
    max-width: 190px;
    max-height: 95px;
  }
}
// desktop wide -----------------------
@media (min-width: $desktop-wide-min-width) {
}
// desktop ----------------------------
@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
}
// laptop -----------------------------
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
}
// tablet large -----------------------
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
}
// tablet -----------------------------
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
}
// mobile -----------------------------
@media (max-width: $mobile-max-width) {
  .logos-row {
    &__logo-wrap {
      height: 65px;
      padding-right: 45px;
    }

    &__logo {
      max-width: 130px;
      max-height: 65px;
    }
  }
}

// Testimonial snippet ========================================================
.testimonial-snippet {
  @include standardFont;
  box-sizing: border-box;
  padding: 25px 25px 25px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.37);
  background: 25px 19px/42px 28px url(/images/quote-icon.svg) no-repeat;

  &__logo-wrap {
    width: 200px;
    height: 80px;
    display: flex;
    align-self: flex-end;
    justify-content: flex-end;
    align-items: center;
  }

  &__logo {
    width: 100%;
    height: 100%;
    margin-bottom: 17px;
    object-fit: contain;
    object-position: right;
  }

  &__text {
    margin-bottom: 18px;
    color: rgba(91, 91, 91, 1);
    font-weight: 500;
    line-height: 22px;
    white-space: pre-wrap;

    :deep(b) {
      color: rgba(0, 0, 0, 1) !important;
    }
  }

  &__divider {
    width: 200px;
    margin-bottom: 17px;
    border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
  }

  &__name-and-position {
  }

  &__name {
  }

  &__position {
  }
}

// Logos & testimonials carousel ==============================================
.logos-and-testimonials-carousels {
  width: $desktop-wide-content-width;
  position: relative;
  z-index: 2;

  &__title {
    margin: 127px 0 60px;
    text-align: center;
    font-weight: 600;
  }

  &__logos-carousel {
    width: 100%;
    margin: 0 auto 100px;
  }

  &__divider {
    max-width: var(--grid-content-full-width);
    margin: 0 auto 75px;
    border-bottom: 1px rgba(0, 0, 0, 0.1) solid;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__quotes-carousel {
    width: 100%;
    margin: 0 auto 65px;
  }
}
// desktop wide -----------------------
@media (min-width: $desktop-wide-min-width) {
}
// desktop ----------------------------
@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
  .logos-and-testimonials-carousels {
    width: $desktop-content-width;
  }
}
// laptop -----------------------------
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
  .logos-and-testimonials-carousels {
    width: $laptop-content-width;
  }
}
// tablet large -----------------------
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
  .logos-and-testimonials-carousels {
    width: $tablet-large-content-width;

    &__title {
      margin: 100px 0 50px;
    }

    &__logos-carousel {
      margin: 0 auto 90px;
    }

    &__divider {
      margin: 0 auto 65px;
    }

    &__quotes-carousel {
      margin: 0 auto 25px;
    }
  }
}
// tablet -----------------------------
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
  .logos-and-testimonials-carousels {
    width: $tablet-content-width;

    &__title {
      margin: 80px 0 50px;
    }

    &__logos-carousel {
      margin: 0 auto 70px;
    }

    &__divider {
      margin: 0 auto 45px;
    }

    &__quotes-carousel {
      margin: 0 auto 25px;
    }
  }
}
// mobile -----------------------------
@media (max-width: $mobile-max-width) {
  .logos-and-testimonials-carousels {
    width: $mobile-content-width;

    &__title {
      margin: 57px 0 30px;
    }

    &__logos-carousel {
      margin: 0 auto 50px;
    }

    &__divider {
      margin: 0 auto 35px;
    }

    &__quotes-carousel {
      margin: 0 auto 15px;
    }
  }
}

// Customer Quotes page =======================================================
.customer-quotes-page {
  width: $desktop-wide-content-width;
  margin: 0 auto;
}
// desktop wide -----------------------
@media (min-width: $desktop-wide-min-width) {
}
// desktop ----------------------------
@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
  .customer-quotes-page {
    width: $desktop-content-width;
  }
}
// laptop -----------------------------
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
  .customer-quotes-page {
    width: $laptop-content-width;
  }
}
// tablet large -----------------------
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
  .customer-quotes-page {
    width: $tablet-large-content-width;
  }
}
// tablet -----------------------------
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
  .customer-quotes-page {
    width: $tablet-content-width;
  }
}
// mobile -----------------------------
@media (max-width: $mobile-max-width) {
  .customer-quotes-page {
    width: $mobile-content-width;
  }
}
</style>
